import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  UpdateEmailNotificationRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getEmailNotifications = async (
  instance: AxiosInstance,
  userId: string
) => {
  return await userApiDefaultApiFactory(instance).getEmailNotifications({
    userId,
  })
}

export const updateEmailNotification = async (
  instance: AxiosInstance,
  userId: string,
  emailNotificationId: string,
  params: UpdateEmailNotificationRequest
) => {
  return await userApiDefaultApiFactory(instance).updateEmailNotification({
    emailNotificationId,
    updateEmailNotificationRequest: params,
    userId,
  })
}

// Do Not Remove this line ===@import api client===
